import React, { useState, useEffect } from 'react';
import { Container, Typography, TextField, Button, Box, Paper, List, ListItem, ListItemText, Grid, Tabs, Tab, MenuItem, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchPrograms, createProgram, scheduleClass, fetchClasses, deleteProgram, deleteClass } from '../api/client';

const AdminPage = () => {
    const [tab, setTab] = useState(0);
    const [programs, setPrograms] = useState([]);
    const [classes, setClasses] = useState([]);

    // Forms
    const [progForm, setProgForm] = useState({ title: '', description: '', track: 'Right Brain Intensive', price_credits: 1 });
    const [scheduleForm, setScheduleForm] = useState({ program_id: '', instructor: '', schedule_time: '', capacity: 10 });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        const p = await fetchPrograms();
        const c = await fetchClasses();
        setPrograms(p);
        setClasses(c);
    };

    const handleCreateProg = async (e) => {
        e.preventDefault();
        await createProgram(progForm);
        alert('Program Created');
        loadData();
    };

    const handleScheduleResult = async (e) => {
        e.preventDefault();
        await scheduleClass(scheduleForm);
        alert('Class Scheduled!');
        loadData();
    };

    const handleDeleteProg = async (id) => {
        if (window.confirm('Delete this program?')) {
            await deleteProgram(id);
            loadData();
        }
    };

    const handleDeleteClass = async (id) => {
        if (window.confirm('Cancel this class?')) {
            await deleteClass(id);
            loadData();
        }
    };

    return (
        <Container maxWidth="lg" sx={{ mt: 4 }}>
            <Typography variant="h4" gutterBottom>Admin Dashboard</Typography>
            <Tabs value={tab} onChange={(e, v) => setTab(v)} sx={{ mb: 4 }}>
                <Tab label="Programs (Catalog)" />
                <Tab label="Schedule Classes" />
            </Tabs>

            {tab === 0 && (
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 3 }}>
                            <Typography variant="h6">Create New Program</Typography>
                            <form onSubmit={handleCreateProg}>
                                <TextField fullWidth label="Title" margin="normal" value={progForm.title} onChange={e => setProgForm({ ...progForm, title: e.target.value })} required />
                                <TextField fullWidth label="Description" margin="normal" multiline rows={3} value={progForm.description} onChange={e => setProgForm({ ...progForm, description: e.target.value })} />
                                <TextField select fullWidth label="Track" margin="normal" value={progForm.track} onChange={e => setProgForm({ ...progForm, track: e.target.value })}>
                                    {['Right Brain Intensive', 'Little Polyglot', 'Heart & Harmony', 'Preschool Prep'].map((opt) => (
                                        <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                    ))}
                                </TextField>
                                <Button type="submit" variant="contained" sx={{ mt: 2 }}>Create Program</Button>
                            </form>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Existing Programs</Typography>
                        <List>
                            {programs.map(p => (
                                <ListItem key={p.id} sx={{ bgcolor: 'background.paper', mb: 1, borderRadius: 1 }} secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteProg(p.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                }>
                                    <ListItemText primary={p.title} secondary={p.track} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            )}

            {tab === 1 && (
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6}>
                        <Paper sx={{ p: 3 }}>
                            <Typography variant="h6">Schedule a Session</Typography>
                            <form onSubmit={handleScheduleResult}>
                                <TextField select fullWidth label="Select Program" margin="normal" value={scheduleForm.program_id} onChange={e => setScheduleForm({ ...scheduleForm, program_id: e.target.value })} required>
                                    {programs.map(p => (
                                        <MenuItem key={p.id} value={p.id}>{p.title}</MenuItem>
                                    ))}
                                </TextField>
                                <TextField fullWidth label="Instructor" margin="normal" value={scheduleForm.instructor} onChange={e => setScheduleForm({ ...scheduleForm, instructor: e.target.value })} required />
                                <TextField fullWidth type="datetime-local" label="Date & Time" InputLabelProps={{ shrink: true }} margin="normal" value={scheduleForm.schedule_time} onChange={e => setScheduleForm({ ...scheduleForm, schedule_time: e.target.value })} required />
                                <Button type="submit" variant="contained" color="secondary" sx={{ mt: 2 }}>Schedule Class</Button>
                            </form>
                        </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Upcoming Scheduled Classes</Typography>
                        <List>
                            {classes.map(c => (
                                <ListItem key={c.id} sx={{ bgcolor: 'background.paper', mb: 1, borderRadius: 1 }} secondaryAction={
                                    <IconButton edge="end" aria-label="delete" onClick={() => handleDeleteClass(c.id)}>
                                        <DeleteIcon />
                                    </IconButton>
                                }>
                                    <ListItemText primary={`${c.title} (${c.instructor})`} secondary={new Date(c.schedule_time).toLocaleString()} />
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
};

export default AdminPage;
